import { useEffect } from 'react';
import { PAGINATION_PAGE_PARAM, PAGINATION_PAGE_SIZE_PARAM } from '@shared/constants/pagination.constants';
import { useSearchParams } from './useSearchParams.hook';

// Clamp an out-of-range page: archiving the last item on page N, or a stale
// deep link, lands on an empty page while total > 0. The Pagination component
// cannot do this itself - lists hide it while they show an empty state.
export const usePageClamp = (data: { items: unknown[]; total: number } | undefined, isLoading: boolean) => {
  const { searchParams, changeMany } = useSearchParams();
  const page = Number(searchParams.get(PAGINATION_PAGE_PARAM));
  const pageSize = Number(searchParams.get(PAGINATION_PAGE_SIZE_PARAM));

  useEffect(() => {
    if (!data || isLoading) return;
    if (!pageSize || page <= 1) return;
    if (data.items.length > 0) return;
    if (data.total === 0) return;
    const lastPage = Math.max(1, Math.ceil(data.total / pageSize));
    if (page > lastPage) changeMany({ [PAGINATION_PAGE_PARAM]: String(lastPage) });
  }, [data, isLoading, page, pageSize]);
};
